<template>
    <div v-if="show_form">
        <form id="settings_form">
            <div id="message_div"></div>
            <kt-row>
                <kt-col lg="12" md="12" sm="12">
                    <kt-form-label>
                        {{ $t('label.chose_default_psp') }}
                    </kt-form-label>
                </kt-col>
                <kt-col lg="3" md="4" sm="12" style="margin-top: 15px">
                    <kt-form-group>
                        <kt-form-label for="default_psp">
                            {{ $t('label.psp') }}
                        </kt-form-label>
                        <kt-form-select
                                id="default_psp"
                                name="default_psp"
                                @change="setSettings"
                                v-model="general_settings.default_psp"
                                class="form-control"
                        >
                            <option
                                    v-bind:key="index"
                                    v-for="(psp, index) in activeBillPsp"
                                    v-bind:value="psp.value"
                                    :selected="psp.value === general_settings.default_psp"
                            >
                                {{ psp.title }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
                <kt-col style="margin-top: 15px"
                        v-if="general_settings.default_psp" lg="3" md="4" sm="12">
                    <kt-form-group>
                        <kt-form-label v-show="general_settings.default_psp == pspList.PASARGAD" for="default_corporate">
                            {{ $t('label.chose_default_corporate') }}
                        </kt-form-label>
                        <kt-form-label v-show="general_settings.default_psp == pspList.MELLAT" for="default_corporate">
                            {{ $t('bill-service.chose_mellat_bill_code') }}
                        </kt-form-label>
                        <select
                                id="default_corporate"
                                name="default_corporate"
                                v-model="general_settings.default_corporate"
                                class="form-control"
                        >
                            <option value="" :selected="general_settings.default_corporate == ''">
                                {{ $t('selectpicker.nothing_selected') }}
                            </option>
                            <option
                                    v-for="corporate in psp_corporates"
                                    v-bind:key="corporate.id"
                                    v-bind:value="corporate.id"
                                    :selected="general_settings.default_corporate == corporate.id"
                            >
                                {{ corporate.business_name }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col style="margin-top: 15px"
                        v-if="general_settings.default_psp" lg="3" md="4" sm="12">
                    <kt-form-group>
                        <kt-form-label for="default_shop">
                            {{ $t('label.chose_default_shop') }}
                        </kt-form-label>
                        <select
                                id="default_shop"
                                name="default_shop"
                                v-model="general_settings.default_shop"
                                class="form-control "
                        >
                            <option value="" :selected="general_settings.default_shop == ''">
                                {{ $t('selectpicker.nothing_selected') }}
                            </option>
                            <option
                                    v-for="default_shop in psp_shops"
                                    v-bind:key="default_shop.id"
                                    v-bind:value="default_shop.id"
                                    :selected="general_settings.default_shop == default_shop.id"
                            >
                                {{ default_shop.name }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <hr>
            <kt-row style="margin-top: 17px">
                <kt-col lg="12" md="12" sm="12">
                    <kt-form-label>
                        {{ $t('label.chose_default_ivr_bill_generator') }}
                    </kt-form-label>
                </kt-col>
                <kt-col style="margin-top: 15px" lg="3" md="4" sm="12">
                    <kt-form-group>
                        <kt-form-label for="ivr_default_bill_generator">
                            {{ $t('label.chose_corporate') }}
                        </kt-form-label>
                        <kt-form-select
                                id="ivr_default_bill_generator"
                                name="ivr_default_bill_generator"
                                v-model="general_settings.ivr_default_bill_generator"
                                class="form-control"
                        >
                            <option
                                    v-for="corporate in ivr_bill_generators"
                                    v-bind:key="corporate.id"
                                    v-bind:value="corporate.id"
                                    :selected="general_settings.default_corporate == corporate.id"
                            >
                                {{ corporate.business_name }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-form-action  class="mt-2">
                <button style="margin-top: 25px" class="btn btn-md btn-success btn-wide"
                        @click.prevent="updateSettings"
                        type="submit" id="change_settings_btn">
                    {{ $t('btn.edit') }}
                </button>
            </kt-form-action>
        </form>
    </div>
</template>

<script>
import $ from "jquery"
import {i18n} from '@/plugins/i18n'
import {mapGetters} from "vuex"
import {KTApp} from '@/plugins/core/app'
import {billService} from '@/common/api.service'
import {pspList, activeBillPsp} from '@/constants/psp'

export default {
    computed: {
        ...mapGetters('bill', [
            'corporates', 'active_collective_gateways'
        ]),
    },
    mounted() {
        this.$store.dispatch('bill/getCorporates')
        this.$store.dispatch('bill/getActiveCollectiveGateways')
        billService.getGeneralSettings().then(response => {
            this.general_settings = response.data.data
            this.setSettings(true)
            this.setIvrBillGenerators()
            this.show_form = true
            this.afterDispatch()
        })
    },
    data() {
        return {
            is: 0,
            activeBillPsp,
            general_settings: {},
            ivr_bill_generators:[],
            psp_shops: null,
            psp_corporates: null,
            show_form: false,
            pspList,
        }
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        setSettings(is_first_try) {
            if (!is_first_try) {
                this.general_settings.default_shop = null
                this.general_settings.default_corporate = null
            }

            let psp = this.general_settings.default_psp
            this.psp_corporates = []
            this.psp_shops = []
            for (let i = 0; i < this.active_collective_gateways.length; i++) {
                if (this.active_collective_gateways[i]['psp'] === psp) {
                    this.psp_shops.push(this.active_collective_gateways[i])
                }
            }
            for (let i = 0; i < this.corporates.length; i++) {
                if (this.corporates[i]['psp'] === psp) {
                    this.psp_corporates.push(this.corporates[i])
                }
            }
        },
        setIvrBillGenerators(){
            for (let i = 0; i < this.corporates.length; i++) {
                if (this.corporates[i]['psp'] === 'mellat') {
                    this.ivr_bill_generators.push(this.corporates[i])
                }
            }
            console.log(this.ivr_bill_generators)
        },
        refresh() {
            this.general_settings.default_psp = null
            let general_settings = this.general_settings
        },
        updateSettings() {
            // return console.log(this.general_settings)
            let btn = $('#change_settings_btn')
            let form = $('#settings_form')
            form.validate({
                rules: {
                    default_psp: {
                        required: true
                    },
                    default_corporate: {
                        required:true
                    },
                    default_shop: {
                        required: true
                    },
                    ivr_default_bill_generator: {
                        required: true
                    }
                }
            })

            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)

            billService.updateSettings(this.general_settings).then(response => {
                this.showMsg(form, 'success', i18n.t('message.edit_success'))
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(response => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>

<style>

</style>